import type {BaseItemObject} from '@PosterWhiteboard/items/item/item.types';
import type {TextStylesObject, TextVerticalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import type {TextBackgroundObject} from '@PosterWhiteboard/items/text-item/text-background';
import type {TextLineStylesObject, TextStyleRunObject} from '@PosterWhiteboard/items/text-item/text-style-runs.types';
import type {TOriginY} from '@postermywall/fabricjs-2';

export interface TextItemObject extends BaseItemObject {
  baseWidth: number;
  fontFamily: string;
  verticalAlign: TextVerticalAlignType;
  verticalPadding: number;
  padding: number;
  background: TextBackgroundObject;
  textStyles: TextStylesObject;
  text: string;
  styleRuns: TextStyleRunObject[];
  /** Keyed by the REAL (unwrapped) line index as a decimal string — JSON object keys are always strings, even when they look numeric in devtools. */
  lineStyles: Record<string, TextLineStylesObject>;
}

/** How an edit session opens: a freshly added item selects its placeholder text so typing replaces it. */
export interface EnterEditModeOpts {
  selectAllText?: boolean;
}

export const TEXT_ITEM_PADDING_MAX = 100;
export const FONT_SIZE_MIN = 1;
export const FONT_SIZE_MAX = 999;

export const DEFAULT_TEXT_SHADOW_DISTANCE = 4;
export const DEFAULT_TEXT_SHADOW_BLUR = 1;

/** Canvas-space placement for a text-child-shaped object (edit clone, animation clip path). */
export interface ClonePositionalParams {
  left: number;
  top: number;
  originY?: TOriginY;
}
